import React, {useEffect, useRef, useState} from "react";
import images, {ImagesType} from "components/UI/images";
import {IconsSocialsType} from "components/UI/icons/socials";
import Dropdown from "components/UI/Dropdown";

type HeaderType = {
    isHidden: boolean
}

const Header: React.FC<HeaderType> = (
    {
        isHidden,
    }
) => {
    const [isActiveMenu, setIsActiveMenu] = useState<boolean>(false);

    const [dropdowns, setDropdowns] = useState<dropdownType>(dropdownsState);
    const socialDropdownRef = useRef<HTMLDivElement>(null);
    const projectDropdownRef = useRef<HTMLDivElement>(null);
    const {ImageLogo, ImageLogoMobile} = images;

    const handleClickOutside = () => {
        setDropdowns((prevState) => {
            let key: dropdownsStateKey = "" as dropdownsStateKey;

            for (key in prevState) {
                prevState[key] = false;
            }

            return {...prevState};
        });
    };

    const openMenu = () => {
        setIsActiveMenu(!isActiveMenu);
        document.body.classList.toggle("overflow-hidden");
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside);

        return () => document.removeEventListener('click', handleClickOutside);
    }, [dropdowns]);

    return (
        <div className={`header ${isHidden ? "header--hidden" : ""}`}>
            <div className="header__container">
                <div className="header__logo">
                    <picture>
                        <source srcSet={ImageLogoMobile} media="(max-width: 768px)"/>
                        <img src={ImageLogo} alt="Iggy Dance &amp; DJ" title="Iggy Dance &amp; DJ"/>
                    </picture>
                </div>
                <button onClick={openMenu}
                        className={`header__menu-btn ${isActiveMenu ? "header__menu-btn--close" : ""}`}>
                    Open menu
                    <span aria-label="burger"/>
                    <span aria-label="burger"/>
                    <span aria-label="burger"/>
                </button>
                <div className={`header__navigation ${isActiveMenu ? "header__navigation--open" : ""}`}>
                    <nav className="header__nav">
                        {
                            navLinks.map((link, index) => (
                                <a key={index} href={link.url} target="_blank" rel="noreferrer"
                                   className="header__nav-link">{link.text}</a>
                            ))
                        }
                    </nav>
                    <div className="header__dropdowns">
                        <Dropdown setCurrent={setDropdowns} ref={socialDropdownRef} isOpen={dropdowns.social}
                                  type="social" variant="default" body={{socialList}} head={
                            {text: "Social Media", element: "ElementIconSocial"}
                        }/>

                        <Dropdown setCurrent={setDropdowns} ref={projectDropdownRef} isOpen={dropdowns.project}
                                  type="project" variant="line" body={{projectList}} head={
                            {text: "Projects", element: "ElementImageProject"}
                        }/>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Header;

export type SocialListType = {
    url: string,
    icon: IconsSocialsType,
    text: string,
}

export type ProjectListType = {
    url: string,
    images: ImagesType[],
    text: string,
}

export type NavLinkType = {
    url: string,
    text: string,
}

export type dropdownType = { social: boolean, project: boolean };

export const dropdownsState: dropdownType = {social: false, project: false};

export type dropdownsStateKey = keyof typeof dropdownsState;

export const navLinks: NavLinkType[] = [
    {url: "https://challenge.1ath.studio/season1#benefits", text: "Live Event"},
    {url: "https://challenge.1ath.studio/season1#tabs", text: "Apply Now"},
    {url: "https://challenge.1ath.studio/season1#tab", text: "Prize Pool"},
    {url: "https://challenge.1ath.studio/season1#win", text: "How to win"},
    {url: "https://challenge.1ath.studio/season1#iggy", text: "Who's Iggy"},
    {url: "https://challenge.1ath.studio/season1#faq", text: "FAQ"},
];

export const projectList: ProjectListType[] = [
    {url: "https://challenge.1ath.studio/season1", text: "Auth Studio Season 1", images: ["ImageSeason1"]},
    {url: "https://iggyboy.1ath.studio/", text: "Iggy Boy", images: ["ImageIggy", "ImageIggyColor"]},
    {url: "https://1ath.studio/", text: "Ath Studio", images: ["ImageAthStudio", "ImageAthStudioColor"]},
    {
        url: "https://challenge.1ath.studio/season2",
        text: "Auth Studio Season 2",
        images: ["ImageSeason2", "ImageSeason2Color"]
    },
];

export const socialList: SocialListType[] = [
    {url: "https://twitter.com/1ATHStudio", text: "Twitter", icon: "IconTwitter"},
    {url: "https://www.instagram.com/1ath.studio/", text: "Instagram", icon: "IconInstagram"},
    {url: "https://www.tiktok.com/@1ath.studio", text: "Tik Tok", icon: "IconTiktok"},
    {url: "https://www.youtube.com/c/1ATHStudio/videos", text: "Youtube", icon: "IconYoutube"},
    {url: "https://discord.com/invite/1athstudio", text: "Discord", icon: "IconDiscord"},
    {url: "https://1athstudio.medium.com/", text: "Medium", icon: "IconMedium"},
    {url: "https://www.reddit.com/r/1ATHStudio/", text: "Reddit", icon: "IconReddit"},
    {url: "https://www.linkedin.com/company/1athstudio/", text: "Linkedin", icon: "IconLinkedin"},
    {url: "https://opensea.io/collection/iggyboy-1athstudio", text: "Opensea", icon: "IconOpensea"},
    {url: "https://www.facebook.com/1ATH.Studio", text: "Facebook", icon: "IconFacebook"},
];